<template>
  <div>
    <main class="contenedor contenido-principal text-center sombra">
      <conoce-mas></conoce-mas>
      <los-iconos></los-iconos>
      <LaGaleria  />
    </main>
    <NuestroMenu  />
    <LosTestimoniales  />
  </div>
</template>

<script>
import ConoceMas from '../sections/ConoceMas.vue';
import LosIconos from '../sections/LosIconos.vue';
import LosTestimoniales from '../sections/LosTestimoniales.vue';
import NuestroMenu from '../sections/NuestroMenu.vue';
import LaGaleria from '../sections/LaGaleria.vue';

export default {
  components: {
    ConoceMas,
    LosIconos,
    LosTestimoniales,
    NuestroMenu,
    LaGaleria
  }
}
</script>